import { useState, useEffect } from "react";
import { collection, doc, getDocs, setDoc, deleteDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import Icon from "./Icon";

// ─── Built-in starter templates ───────────────────────────────────────────────
// seasons: "all" | "summer" | "winter" | "fall"
// qty: number (optional) — renders as ×N badge, editable inline

const BUILTIN_TEMPLATES = [
  {
    id: "builtin-urban",
    name: "Urban",
    emoji: "🏙️",
    items: [
      { id: "u-h1",  type: "heading", label: "Clothes" },
      { id: "u1",    label: "T-shirts",           qty: 3,    seasons: "all",    gender: "all" },
      { id: "u2",    label: "Dinner shirts",       qty: 4,    seasons: "all",    gender: "male" },
      { id: "u2f",   label: "Blouses / tops",      qty: 4,    seasons: "all",    gender: "female" },
      { id: "u3",    label: "Casual shirts",       qty: 3,    seasons: "all",    gender: "male" },
      { id: "u3f",   label: "Casual tops",         qty: 3,    seasons: "all",    gender: "female" },
      { id: "u3fa",  label: "Dress / skirt",       qty: 2,    seasons: "all",    gender: "female" },
      { id: "u4",    label: "Pants / jeans",       qty: 3,    seasons: "all",    gender: "all" },
      { id: "u5",    label: "Shorts",              qty: 1,    seasons: "all",    gender: "all" },
      { id: "u6",    label: "Swimsuit",            qty: 1,    seasons: "all",    gender: "all" },
      { id: "u6f",   label: "Bras",                qty: 4,    seasons: "all",    gender: "female" },
      { id: "u7",    label: "Underwear",           qty: 5,    seasons: "all",    gender: "all" },
      { id: "u8",    label: "Socks",               qty: 4,    seasons: "all",    gender: "all" },
      { id: "u9",    label: "Dress socks",         qty: 3,    seasons: "all",    gender: "male" },
      { id: "u9f",   label: "Tights / hosiery",    qty: 2,    seasons: "all",    gender: "female" },
      { id: "u10",   label: "Belt",                qty: null, seasons: "all",    gender: "all" },
      { id: "u11",   label: "Jacket / blazer",     qty: null, seasons: "all",    gender: "all" },
      { id: "u12",   label: "Fleece",              qty: null, seasons: "all",    gender: "all" },
      { id: "u13",   label: "Light layer",         qty: 1,    seasons: "summer", gender: "all" },
      { id: "u14",   label: "Warm coat",           qty: 1,    seasons: "winter", gender: "all" },
      { id: "u15",   label: "Scarf",               qty: 1,    seasons: "winter", gender: "all" },
      { id: "u16",   label: "Gloves",              qty: 1,    seasons: "winter", gender: "all" },
      { id: "u-h2",  type: "heading", label: "Shoes" },
      { id: "u17",   label: "Dress shoes",         qty: 1,    seasons: "all",    gender: "all" },
      { id: "u17f",  label: "Heels",               qty: 1,    seasons: "all",    gender: "female" },
      { id: "u18",   label: "Casual shoes",        qty: 1,    seasons: "all",    gender: "all" },
      { id: "u19",   label: "Sandals",             qty: null, seasons: "all",    gender: "all" },
      { id: "u-h3",  type: "heading", label: "Other" },
      { id: "u20",   label: "Passport / ID",       qty: null, seasons: "all",    gender: "all" },
      { id: "u21",   label: "Wallet",              qty: null, seasons: "all",    gender: "all" },
      { id: "u22",   label: "Phone charger",       qty: null, seasons: "all",    gender: "all" },
      { id: "u23",   label: "Power adapter",       qty: null, seasons: "all",    gender: "all" },
      { id: "u24",   label: "Ear buds",            qty: null, seasons: "all",    gender: "all" },
      { id: "u25",   label: "Kindle",              qty: null, seasons: "all",    gender: "all" },
      { id: "u26",   label: "Sunglasses",          qty: null, seasons: "all",    gender: "all" },
      { id: "u27",   label: "Sunscreen",           qty: 1,    seasons: "summer", gender: "all" },
      { id: "u28",   label: "Umbrella",            qty: null, seasons: "fall",   gender: "all" },
      { id: "u29",   label: "Toiletries",          qty: null, seasons: "all",    gender: "all" },
      { id: "u30",   label: "Medications",         qty: null, seasons: "all",    gender: "all" },
      { id: "u30f",  label: "Makeup / cosmetics",  qty: null, seasons: "all",    gender: "female" },
      { id: "u31f",  label: "Hair accessories",    qty: null, seasons: "all",    gender: "female" },
    ],
  },
  {
    id: "builtin-beach",
    name: "Beach",
    emoji: "🏖️",
    items: [
      { id: "b-h1",  type: "heading", label: "Clothes" },
      { id: "b1",    label: "Swimsuit",            qty: 2,    seasons: "all",    gender: "all" },
      { id: "b1f",   label: "Bikini top",          qty: 2,    seasons: "all",    gender: "female" },
      { id: "b2",    label: "T-shirts",            qty: 3,    seasons: "all",    gender: "all" },
      { id: "b3",    label: "Dinner shirts",       qty: 4,    seasons: "all",    gender: "male" },
      { id: "b3f",   label: "Blouses / dinner tops", qty: 4,  seasons: "all",    gender: "female" },
      { id: "b3fa",  label: "Sundress / skirt",    qty: 2,    seasons: "all",    gender: "female" },
      { id: "b4",    label: "Shorts",              qty: 2,    seasons: "all",    gender: "all" },
      { id: "b5",    label: "Long pants",          qty: 3,    seasons: "all",    gender: "all" },
      { id: "b6",    label: "Light cover-up",      qty: 1,    seasons: "all",    gender: "all" },
      { id: "b6f",   label: "Bras",                qty: 3,    seasons: "all",    gender: "female" },
      { id: "b7",    label: "Underwear",           qty: 5,    seasons: "all",    gender: "all" },
      { id: "b8",    label: "Socks",               qty: 3,    seasons: "all",    gender: "all" },
      { id: "b9",    label: "Dress socks",         qty: 3,    seasons: "all",    gender: "male" },
      { id: "b10",   label: "Fleece",              qty: null, seasons: "all",    gender: "all" },
      { id: "b11",   label: "Light jacket",        qty: null, seasons: "fall",   gender: "all" },
      { id: "b12",   label: "Warm layer",          qty: 1,    seasons: "winter", gender: "all" },
      { id: "b-h2",  type: "heading", label: "Shoes" },
      { id: "b13",   label: "Flip flops",          qty: 1,    seasons: "all",    gender: "all" },
      { id: "b14",   label: "Sneakers",            qty: 1,    seasons: "all",    gender: "all" },
      { id: "b15",   label: "Sandals",             qty: null, seasons: "all",    gender: "all" },
      { id: "b-h3",  type: "heading", label: "Other" },
      { id: "b16",   label: "Passport / ID",       qty: null, seasons: "all",    gender: "all" },
      { id: "b17",   label: "Phone charger",       qty: null, seasons: "all",    gender: "all" },
      { id: "b18",   label: "Power adapter",       qty: null, seasons: "all",    gender: "all" },
      { id: "b19",   label: "Ear buds",            qty: null, seasons: "all",    gender: "all" },
      { id: "b20",   label: "Kindle",              qty: null, seasons: "all",    gender: "all" },
      { id: "b21",   label: "Sunglasses",          qty: null, seasons: "all",    gender: "all" },
      { id: "b22",   label: "Sunscreen SPF 50+",   qty: 1,    seasons: "all",    gender: "all" },
      { id: "b23",   label: "Hat",                 qty: null, seasons: "all",    gender: "all" },
      { id: "b24",   label: "Beach towel",         qty: 1,    seasons: "all",    gender: "all" },
      { id: "b25",   label: "Waterproof bag",      qty: null, seasons: "all",    gender: "all" },
      { id: "b26",   label: "Insect repellent",    qty: null, seasons: "all",    gender: "all" },
      { id: "b27",   label: "Toiletries",          qty: null, seasons: "all",    gender: "all" },
      { id: "b28",   label: "Medications",         qty: null, seasons: "all",    gender: "all" },
      { id: "b28f",  label: "Makeup / cosmetics",  qty: null, seasons: "all",    gender: "female" },
      { id: "b29f",  label: "Hair accessories",    qty: null, seasons: "all",    gender: "female" },
      { id: "b30f",  label: "Feminine hygiene",    qty: null, seasons: "all",    gender: "female" },
    ],
  },
  {
    id: "builtin-business",
    name: "Business",
    emoji: "💼",
    items: [
      { id: "bs-h1", type: "heading", label: "Clothes" },
      { id: "bs1",   label: "Dress shirts",        qty: 3,    seasons: "all",    gender: "male" },
      { id: "bs1f",  label: "Blouses",             qty: 3,    seasons: "all",    gender: "female" },
      { id: "bs2",   label: "Dinner shirts",       qty: 4,    seasons: "all",    gender: "male" },
      { id: "bs2f",  label: "Evening tops",        qty: 4,    seasons: "all",    gender: "female" },
      { id: "bs3",   label: "T-shirts",            qty: 3,    seasons: "all",    gender: "all" },
      { id: "bs4",   label: "Suit / blazer",       qty: 1,    seasons: "all",    gender: "all" },
      { id: "bs4f",  label: "Dress / skirt suit",  qty: 1,    seasons: "all",    gender: "female" },
      { id: "bs5",   label: "Long pants",          qty: 3,    seasons: "all",    gender: "all" },
      { id: "bs5f",  label: "Dress / skirt",       qty: 2,    seasons: "all",    gender: "female" },
      { id: "bs6",   label: "Shorts",              qty: 1,    seasons: "all",    gender: "all" },
      { id: "bs7",   label: "Swimsuit",            qty: 1,    seasons: "all",    gender: "all" },
      { id: "bs7f",  label: "Bras",                qty: 4,    seasons: "all",    gender: "female" },
      { id: "bs8",   label: "Underwear",           qty: 5,    seasons: "all",    gender: "all" },
      { id: "bs9",   label: "Dress socks",         qty: 3,    seasons: "all",    gender: "male" },
      { id: "bs9f",  label: "Tights / hosiery",    qty: 2,    seasons: "all",    gender: "female" },
      { id: "bs10",  label: "Tie / accessories",   qty: null, seasons: "all",    gender: "male" },
      { id: "bs10f", label: "Jewelry / scarves",   qty: null, seasons: "all",    gender: "female" },
      { id: "bs11",  label: "Casual outfit",       qty: 1,    seasons: "all",    gender: "all" },
      { id: "bs12",  label: "Fleece",              qty: null, seasons: "all",    gender: "all" },
      { id: "bs13",  label: "Overcoat",            qty: 1,    seasons: "winter", gender: "all" },
      { id: "bs14",  label: "Scarf",               qty: 1,    seasons: "winter", gender: "all" },
      { id: "bs15",  label: "Gloves",              qty: 1,    seasons: "winter", gender: "all" },
      { id: "bs-h2", type: "heading", label: "Shoes" },
      { id: "bs16",  label: "Dress shoes",         qty: 1,    seasons: "all",    gender: "male" },
      { id: "bs16f", label: "Heels / dress flats", qty: 1,    seasons: "all",    gender: "female" },
      { id: "bs17",  label: "Casual shoes",        qty: 1,    seasons: "all",    gender: "all" },
      { id: "bs18",  label: "Sandals",             qty: null, seasons: "all",    gender: "all" },
      { id: "bs-h3", type: "heading", label: "Other" },
      { id: "bs19",  label: "Passport / ID",       qty: null, seasons: "all",    gender: "all" },
      { id: "bs20",  label: "Wallet",              qty: null, seasons: "all",    gender: "all" },
      { id: "bs21",  label: "Laptop",              qty: null, seasons: "all",    gender: "all" },
      { id: "bs22",  label: "Laptop charger",      qty: null, seasons: "all",    gender: "all" },
      { id: "bs23",  label: "Phone charger",       qty: null, seasons: "all",    gender: "all" },
      { id: "bs24",  label: "Power adapter",       qty: null, seasons: "all",    gender: "all" },
      { id: "bs25",  label: "Ear buds",            qty: null, seasons: "all",    gender: "all" },
      { id: "bs26",  label: "Kindle",              qty: null, seasons: "all",    gender: "all" },
      { id: "bs27",  label: "Sunglasses",          qty: null, seasons: "all",    gender: "all" },
      { id: "bs28",  label: "Business cards",      qty: null, seasons: "all",    gender: "all" },
      { id: "bs29",  label: "Notebook / pen",      qty: null, seasons: "all",    gender: "all" },
      { id: "bs30",  label: "Toiletries",          qty: null, seasons: "all",    gender: "all" },
      { id: "bs31",  label: "Medications",         qty: null, seasons: "all",    gender: "all" },
      { id: "bs31f", label: "Makeup / cosmetics",  qty: null, seasons: "all",    gender: "female" },
      { id: "bs32f", label: "Hair accessories",    qty: null, seasons: "all",    gender: "female" },
    ],
  },
  {
    id: "builtin-hiking",
    name: "Hiking",
    emoji: "🥾",
    items: [
      { id: "h-h1",  type: "heading", label: "Clothes" },
      { id: "h1",    label: "Moisture-wick shirts", qty: 3, seasons: "all",    gender: "all" },
      { id: "h2",    label: "T-shirts",          qty: 3,    seasons: "all",    gender: "all" },
      { id: "h3",    label: "Dinner shirts",      qty: 4,    seasons: "all",    gender: "male" },
      { id: "h3f",   label: "Dinner tops",        qty: 4,    seasons: "all",    gender: "female" },
      { id: "h4",    label: "Long pants",        qty: 3,    seasons: "all",    gender: "all" },
      { id: "h5",    label: "Shorts",            qty: 1,    seasons: "all",    gender: "all" },
      { id: "h5f",   label: "Skirt / dress",     qty: 1,    seasons: "all",    gender: "female" },
      { id: "h6",    label: "Swimsuit",          qty: 1,    seasons: "all",    gender: "all" },
      { id: "h6f",   label: "Bras",              qty: 3,    seasons: "all",    gender: "female" },
      { id: "h7",    label: "Underpants",        qty: 5,    seasons: "all",    gender: "all" },
      { id: "h8",    label: "Hiking socks",      qty: 4,    seasons: "all",    gender: "all" },
      { id: "h9",    label: "Dress socks",       qty: 3,    seasons: "all",    gender: "male" },
      { id: "h9f",   label: "Tights / hosiery",  qty: 2,    seasons: "all",    gender: "female" },
      { id: "h10",   label: "Rain jacket",       qty: 1,    seasons: "all",    gender: "all" },
      { id: "h11",   label: "Fleece / mid-layer",qty: 1,    seasons: "all",    gender: "all" },
      { id: "h12",   label: "Thermal base layers", qty: 1,  seasons: "winter", gender: "all" },
      { id: "h13",   label: "Warm hat",          qty: 1,    seasons: "winter", gender: "all" },
      { id: "h14",   label: "Gloves",            qty: 1,    seasons: "winter", gender: "all" },
      { id: "h15",   label: "Gaiters",           qty: 1,    seasons: "winter", gender: "all" },
      { id: "h16",   label: "Sunhat",            qty: null, seasons: "summer", gender: "all" },
      { id: "h-h2",  type: "heading", label: "Shoes" },
      { id: "h17",   label: "Hiking boots",      qty: 1,    seasons: "all",    gender: "all" },
      { id: "h18",   label: "Sandals",           qty: null, seasons: "all",    gender: "all" },
      { id: "h-h3",  type: "heading", label: "Other" },
      { id: "h19",   label: "Passport / ID",     qty: null, seasons: "all",    gender: "all" },
      { id: "h20",   label: "Phone charger",     qty: null, seasons: "all",    gender: "all" },
      { id: "h21",   label: "Power adapter",     qty: null, seasons: "all",    gender: "all" },
      { id: "h22",   label: "Ear buds",          qty: null, seasons: "all",    gender: "all" },
      { id: "h23",   label: "Kindle",            qty: null, seasons: "all",    gender: "all" },
      { id: "h24",   label: "Sunglasses",        qty: null, seasons: "all",    gender: "all" },
      { id: "h25",   label: "Sunscreen",         qty: 1,    seasons: "summer", gender: "all" },
      { id: "h26",   label: "Backpack",          qty: null, seasons: "all",    gender: "all" },
      { id: "h27",   label: "Trekking poles",    qty: null, seasons: "all",    gender: "all" },
      { id: "h28",   label: "Headlamp",          qty: null, seasons: "all",    gender: "all" },
      { id: "h29",   label: "First aid kit",     qty: null, seasons: "all",    gender: "all" },
      { id: "h30",   label: "Water bottle",      qty: 1,    seasons: "all",    gender: "all" },
      { id: "h31",   label: "Insect repellent",  qty: null, seasons: "all",    gender: "all" },
      { id: "h32",   label: "Toiletries",        qty: null, seasons: "all",    gender: "all" },
      { id: "h32f",  label: "Makeup / cosmetics",qty: null, seasons: "all",    gender: "female" },
      { id: "h33f",  label: "Hair accessories",  qty: null, seasons: "all",    gender: "female" },
      { id: "h34f",  label: "Feminine hygiene",  qty: null, seasons: "all",    gender: "female" },
      { id: "h33",   label: "Medications",       qty: null, seasons: "all",    gender: "all" },
    ],
  },
  {
    id: "builtin-toiletries",
    name: "Toiletries",
    emoji: "🪥",
    items: [
      { id: "t1",  label: "Contact solution",      qty: null, seasons: "all", gender: "all" },
      { id: "t2",  label: "Contacts",              qty: null, seasons: "all", gender: "all" },
      { id: "t3",  label: "Deodorant",             qty: null, seasons: "all", gender: "all" },
      { id: "t4",  label: "Emergency medicine",    qty: null, seasons: "all", gender: "all" },
      { id: "t5",  label: "Hearing aid batteries", qty: null, seasons: "all", gender: "all" },
      { id: "t6",  label: "Hearing aids",          qty: null, seasons: "all", gender: "all" },
      { id: "t7",  label: "Jock itch cream",       qty: null, seasons: "all", gender: "male" },
      { id: "t8",  label: "Medicine",              qty: null, seasons: "all", gender: "all" },
      { id: "t9",  label: "Painkiller",            qty: null, seasons: "all", gender: "all" },
      { id: "t10", label: "Q-tips",                qty: null, seasons: "all", gender: "all" },
      { id: "t11", label: "Razor",                 qty: null, seasons: "all", gender: "male" },
      { id: "t12", label: "Shaving cream",         qty: null, seasons: "all", gender: "male" },
      { id: "t12f",label: "Razor / hair removal",  qty: null, seasons: "all", gender: "female" },
      { id: "t13", label: "Toothbrush",            qty: null, seasons: "all", gender: "all" },
      { id: "t14", label: "Toothpaste",            qty: null, seasons: "all", gender: "all" },
      { id: "t15f",label: "Makeup / cosmetics",    qty: null, seasons: "all", gender: "female" },
      { id: "t16f",label: "Hair accessories",      qty: null, seasons: "all", gender: "female" },
      { id: "t17f",label: "Feminine hygiene",      qty: null, seasons: "all", gender: "female" },
    ],
  },
  {
    id: "builtin-biking",
    name: "Biking",
    emoji: "🚴",
    items: [
      { id: "bk-h1", type: "heading", label: "Clothes" },
      { id: "bk1",   label: "Cycling jersey",      qty: 3,    seasons: "all",    gender: "all" },
      { id: "bk2",   label: "Bib shorts",          qty: 2,    seasons: "all",    gender: "all" },
      { id: "bk3",   label: "T-shirts",            qty: 3,    seasons: "all",    gender: "all" },
      { id: "bk4",   label: "Dinner shirts",       qty: 4,    seasons: "all",    gender: "male" },
      { id: "bk4f",  label: "Dinner tops",         qty: 4,    seasons: "all",    gender: "female" },
      { id: "bk5",   label: "Long pants",          qty: 3,    seasons: "all",    gender: "all" },
      { id: "bk6",   label: "Shorts",              qty: 1,    seasons: "all",    gender: "all" },
      { id: "bk7",   label: "Swimsuit",            qty: 1,    seasons: "all",    gender: "all" },
      { id: "bk7f",  label: "Bras",                qty: 3,    seasons: "all",    gender: "female" },
      { id: "bk8",   label: "Underpants",          qty: 5,    seasons: "all",    gender: "all" },
      { id: "bk9",   label: "Cycling socks",       qty: 4,    seasons: "all",    gender: "all" },
      { id: "bk10",  label: "Dress socks",         qty: 3,    seasons: "all",    gender: "male" },
      { id: "bk10f", label: "Tights / hosiery",    qty: 2,    seasons: "all",    gender: "female" },
      { id: "bk11",  label: "Cycling gloves",      qty: 1,    seasons: "all",    gender: "all" },
      { id: "bk12",  label: "Arm warmers",         qty: 1,    seasons: "fall",   gender: "all" },
      { id: "bk13",  label: "Leg warmers",         qty: 1,    seasons: "fall",   gender: "all" },
      { id: "bk14",  label: "Fleece",              qty: null, seasons: "all",    gender: "all" },
      { id: "bk15",  label: "Winter cycling jacket", qty: 1,  seasons: "winter", gender: "all" },
      { id: "bk16",  label: "Thermal base layer",  qty: 1,    seasons: "winter", gender: "all" },
      { id: "bk17",  label: "Winter gloves",       qty: 1,    seasons: "winter", gender: "all" },
      { id: "bk18",  label: "Buff / balaclava",    qty: 1,    seasons: "winter", gender: "all" },
      { id: "bk-h2", type: "heading", label: "Shoes" },
      { id: "bk19",  label: "Cycling shoes",       qty: 1,    seasons: "all",    gender: "all" },
      { id: "bk20",  label: "Casual shoes",        qty: 1,    seasons: "all",    gender: "all" },
      { id: "bk21",  label: "Sandals",             qty: null, seasons: "all",    gender: "all" },
      { id: "bk-h3", type: "heading", label: "Other" },
      { id: "bk22",  label: "Passport / ID",       qty: null, seasons: "all",    gender: "all" },
      { id: "bk23",  label: "Phone charger",       qty: null, seasons: "all",    gender: "all" },
      { id: "bk24",  label: "Power adapter",       qty: null, seasons: "all",    gender: "all" },
      { id: "bk25",  label: "Ear buds",            qty: null, seasons: "all",    gender: "all" },
      { id: "bk26",  label: "Kindle",              qty: null, seasons: "all",    gender: "all" },
      { id: "bk27",  label: "Sunglasses",          qty: null, seasons: "all",    gender: "all" },
      { id: "bk28",  label: "Sunscreen",           qty: 1,    seasons: "summer", gender: "all" },
      { id: "bk29",  label: "Helmet",              qty: null, seasons: "all",    gender: "all" },
      { id: "bk30",  label: "Rain cape",           qty: null, seasons: "all",    gender: "all" },
      { id: "bk31",  label: "Saddle bag + tools",  qty: null, seasons: "all",    gender: "all" },
      { id: "bk32",  label: "Spare tubes",         qty: 2,    seasons: "all",    gender: "all" },
      { id: "bk33",  label: "CO2 / mini pump",     qty: null, seasons: "all",    gender: "all" },
      { id: "bk34",  label: "Chamois cream",       qty: null, seasons: "all",    gender: "all" },
      { id: "bk35",  label: "Toiletries",          qty: null, seasons: "all",    gender: "all" },
      { id: "bk35f", label: "Makeup / cosmetics",  qty: null, seasons: "all",    gender: "female" },
      { id: "bk36f", label: "Hair accessories",    qty: null, seasons: "all",    gender: "female" },
      { id: "bk36",  label: "Medications",         qty: null, seasons: "all",    gender: "all" },
    ],
  },
];

const SEASONS = [
  { id: "all",    label: "All seasons" },
  { id: "summer", label: "Spring / Summer" },
  { id: "fall",   label: "Fall" },
  { id: "winter", label: "Winter" },
];

const GENDERS = [
  { id: "all",    label: "All" },
  { id: "male",   label: "♂ Male" },
  { id: "female", label: "♀ Female" },
];

function itemVisible(item, season, gender) {
  if (season !== "all" && item.seasons !== "all" && item.seasons !== season) return false;
  if (gender !== "all") {
    const g = item.gender || "all";
    if (g !== "all" && g !== gender) return false;
  }
  return true;
}

function generateId() {
  return Math.random().toString(36).slice(2, 10);
}

export default function PackingListsPage({ user, onBack }) {
  const [userLists, setUserLists]     = useState(null); // null = loading
  const [activeId, setActiveId]       = useState(null);
  const [season, setSeason]           = useState("all");
  const [gender, setGender]           = useState("all");
  const [editMode, setEditMode]       = useState(false);
  const [saving, setSaving]           = useState(false);

  // Heading state
  const [addingHeading, setAddingHeading]   = useState(false);
  const [newHeadingLabel, setNewHeadingLabel] = useState("");

  // New list modal
  const [showNewModal, setShowNewModal] = useState(false);
  const [newName, setNewName]           = useState("");
  const [newEmoji, setNewEmoji]         = useState("🧳");

  // Edit item state (for editMode)
  const [editingItemId, setEditingItemId] = useState(null);
  const [editingLabel, setEditingLabel]   = useState("");
  const [addingItem, setAddingItem]       = useState(false);
  const [newItemLabel, setNewItemLabel]   = useState("");
  const [newItemQty, setNewItemQty]       = useState("");
  const [newItemSeason, setNewItemSeason] = useState("all");
  const [newItemGender, setNewItemGender] = useState("all");

  // Inline qty editing
  const [editingQtyId, setEditingQtyId] = useState(null);
  const [editingQtyVal, setEditingQtyVal] = useState("");

  // Multi-select mode
  const [selectMode, setSelectMode] = useState(false);
  const [selectedIds, setSelectedIds] = useState(new Set());

  // Load user lists from Firestore
  useEffect(() => {
    const load = async () => {
      try {
        const snap = await getDocs(collection(db, "users", user.uid, "packingLists"));
        const lists = snap.docs.map(d => ({ id: d.id, ...d.data() }));
        setUserLists(lists);
      } catch (e) {
        console.error("Failed to load packing lists", e);
        setUserLists([]);
      }
    };
    load();
  }, [user.uid]);

  // Derive all lists: if user has a saved copy of a builtin, use it entirely
  // (don't merge — user's items array is the source of truth once they've edited)
  const allLists = (() => {
    if (!userLists) return [];
    const userById = {};
    userLists.forEach(l => { userById[l.id] = l; });
    const result = BUILTIN_TEMPLATES.map(b => {
      const saved = userById[b.id];
      if (!saved) return b;
      // User has saved a copy — use their items exclusively, just inherit name/emoji if missing
      return {
        ...b,
        name:  saved.name  ?? b.name,
        emoji: saved.emoji ?? b.emoji,
        items: saved.items ?? b.items,
      };
    });
    const customs = userLists.filter(l => !l.id.startsWith("builtin-"));
    return [...result, ...customs];
  })();

  const activeList = allLists.find(l => l.id === activeId) || null;

  // Save list to Firestore — optimistic local update FIRST so allLists derivation
  // reflects the change immediately, before the Firestore round-trip completes.
  const saveList = async (list) => {
    setSaving(true);
    setUserLists(prev => {
      const existing = prev.find(l => l.id === list.id);
      if (existing) return prev.map(l => l.id === list.id ? { ...list } : l);
      return [...prev, { ...list }];
    });
    try {
      await setDoc(doc(db, "users", user.uid, "packingLists", list.id), {
        name:      list.name,
        emoji:     list.emoji || "🧳",
        items:     list.items,
        updatedAt: serverTimestamp(),
      }, { merge: true });
    } catch (e) {
      console.error("Save failed", e);
    }
    setSaving(false);
  };

  // Toggle check on an item
  const toggleCheck = async (itemId) => {
    if (!activeList) return;
    const updatedItems = activeList.items.map(it =>
      it.id === itemId ? { ...it, checked: !it.checked } : it
    );
    const updatedList = { ...activeList, items: updatedItems };
    await saveList(updatedList);
  };

  // Reset all checks
  const resetChecks = async () => {
    if (!activeList) return;
    const updatedItems = activeList.items.map(it => ({ ...it, checked: false }));
    await saveList({ ...activeList, items: updatedItems });
  };

  // Inline qty edit save
  const saveQty = async (itemId) => {
    if (!activeList) return;
    const val = parseInt(editingQtyVal, 10);
    const updatedItems = activeList.items.map(it =>
      it.id === itemId ? { ...it, qty: isNaN(val) || val < 1 ? null : val } : it
    );
    setEditingQtyId(null);
    await saveList({ ...activeList, items: updatedItems });
  };

  // Edit mode: save item label
  const saveItemLabel = async (itemId) => {
    if (!activeList || !editingLabel.trim()) { setEditingItemId(null); return; }
    const updatedItems = activeList.items.map(it =>
      it.id === itemId ? { ...it, label: editingLabel.trim() } : it
    );
    setEditingItemId(null);
    await saveList({ ...activeList, items: updatedItems });
  };

  // Edit mode: remove item
  const removeItem = async (itemId) => {
    if (!activeList) return;
    const updatedItems = activeList.items.filter(it => it.id !== itemId);
    await saveList({ ...activeList, items: updatedItems });
  };

  // Edit mode: add item
  const addItem = async () => {
    if (!activeList || !newItemLabel.trim()) return;
    const qty = parseInt(newItemQty, 10);
    const newItem = {
      id:      generateId(),
      label:   newItemLabel.trim(),
      qty:     isNaN(qty) || qty < 1 ? null : qty,
      seasons: newItemSeason,
      gender:  newItemGender,
      checked: false,
    };
    const updatedList = { ...activeList, items: [...activeList.items, newItem] };
    setNewItemLabel("");
    setNewItemQty("");
    setNewItemSeason("all");
    setNewItemGender("all");
    setAddingItem(false);
    await saveList(updatedList);
  };

  // Move item(s) to a section — inserts before the NEXT heading (i.e. bottom of section)
  const moveToSection = async (itemIds, targetHeadingId) => {
    if (!activeList) return;
    const idSet = new Set(itemIds);
    const items = activeList.items;

    // Items being moved (preserve order)
    const moving = items.filter(it => idSet.has(it.id));
    // Items staying
    const staying = items.filter(it => !idSet.has(it.id));

    let insertIndex;
    if (targetHeadingId === "__none__") {
      // Move to top (before first heading or item)
      insertIndex = 0;
    } else {
      // Find the target heading in staying array, then find where next heading starts
      const headingIdx = staying.findIndex(it => it.id === targetHeadingId);
      if (headingIdx === -1) { insertIndex = staying.length; }
      else {
        // Find next heading after this one
        let nextHeading = staying.findIndex((it, i) => i > headingIdx && it.type === "heading");
        insertIndex = nextHeading === -1 ? staying.length : nextHeading;
      }
    }

    const result = [
      ...staying.slice(0, insertIndex),
      ...moving,
      ...staying.slice(insertIndex),
    ];
    setSelectedIds(new Set());
    setSelectMode(false);
    await saveList({ ...activeList, items: result });
  };

  // Delete selected items
  const deleteSelected = async () => {
    if (!activeList || selectedIds.size === 0) return;
    if (!window.confirm(`Remove ${selectedIds.size} item${selectedIds.size > 1 ? "s" : ""}?`)) return;
    const updatedItems = activeList.items.filter(it => !selectedIds.has(it.id));
    setSelectedIds(new Set());
    setSelectMode(false);
    await saveList({ ...activeList, items: updatedItems });
  };

  // Toggle item selection
  const toggleSelect = (id) => {
    setSelectedIds(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  // Add heading
  const addHeading = async (label) => {
    if (!activeList || !label.trim()) return;
    const newHeading = { id: generateId(), type: "heading", label: label.trim() };
    await saveList({ ...activeList, items: [...activeList.items, newHeading] });
  };

  // Delete entire list (only user-saved lists)
  const deleteList = async (listId) => {
    if (!window.confirm("Delete this packing list? This cannot be undone.")) return;
    try {
      await deleteDoc(doc(db, "users", user.uid, "packingLists", listId));
      setUserLists(prev => prev.filter(l => l.id !== listId));
      if (activeId === listId) { setActiveId(null); setEditMode(false); }
    } catch (e) {
      console.error("Delete failed", e);
    }
  };

  // Create new list
  const createList = async () => {
    if (!newName.trim()) return;
    const id = "custom-" + generateId();
    const list = {
      id,
      name:  newName.trim(),
      emoji: newEmoji,
      items: [],
    };
    await saveList(list);
    setShowNewModal(false);
    setNewName("");
    setNewEmoji("🧳");
    setActiveId(id);
    setEditMode(true);
  };

  const checkedCount = activeList
    ? activeList.items.filter(it => it.checked && itemVisible(it, season, gender)).length
    : 0;
  const visibleCount = activeList
    ? activeList.items.filter(it => itemVisible(it, season, gender)).length
    : 0;

  const isUserSaved = (listId) => !!userLists?.find(l => l.id === listId);
  const isCustom = (listId) => !listId.startsWith("builtin-");

  // ─── Render ─────────────────────────────────────────────────────────────────
  return (
    <div style={{ minHeight: "100vh", background: "var(--paper)", fontFamily: "var(--font-body)" }}>
      {/* Header */}
      <header className="header">
        <button className="back-btn" onClick={onBack}>
          <Icon name="chevronLeft" size={18} />
        </button>
        <div className="header-logo">Packing Lists</div>
        <div style={{ width: 40 }} />
      </header>

      <main className="main" style={{ paddingBottom: 60 }}>
        {/* Quote banner */}
        <div style={{
          margin: "0 0 20px",
          padding: "10px 14px",
          background: "rgba(192,86,33,0.06)",
          borderLeft: "3px solid var(--accent)",
          borderRadius: "0 8px 8px 0",
        }}>
          <span style={{ fontSize: 13, fontStyle: "italic", color: "var(--ink-light)" }}>
            "Never pack more than you can carry at a dead run for half a mile."
          </span>
        </div>

        {userLists === null ? (
          <div style={{ padding: "40px 0", textAlign: "center", color: "var(--ink-light)", fontSize: 14 }}>
            Loading...
          </div>
        ) : (
          <>
            {/* Template selector */}
            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 11, fontWeight: 600, letterSpacing: "0.08em", color: "var(--ink-faint)", textTransform: "uppercase", marginBottom: 10 }}>
                Your lists
              </div>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                {allLists.map(list => (
                  <button
                    key={list.id}
                    onClick={() => { setActiveId(list.id); setEditMode(false); setSeason("all"); setGender("all"); setEditingItemId(null); setAddingItem(false); }}
                    style={{
                      display: "flex", alignItems: "center", gap: 6,
                      padding: "7px 14px",
                      borderRadius: 20,
                      border: `1.5px solid ${activeId === list.id ? "var(--accent)" : "var(--border)"}`,
                      background: activeId === list.id ? "var(--accent)" : "var(--paper-card)",
                      color: activeId === list.id ? "white" : "var(--ink)",
                      fontSize: 13, fontWeight: 500,
                      cursor: "pointer", fontFamily: "var(--font-body)",
                      transition: "all 0.15s",
                    }}
                  >
                    <span>{list.emoji || "🧳"}</span>
                    <span>{list.name}</span>
                    {isUserSaved(list.id) && (
                      <span style={{ fontSize: 9, opacity: 0.6, marginLeft: 2 }}>✏️</span>
                    )}
                  </button>
                ))}
                <button
                  onClick={() => setShowNewModal(true)}
                  style={{
                    display: "flex", alignItems: "center", gap: 5,
                    padding: "7px 14px",
                    borderRadius: 20,
                    border: "1.5px dashed var(--border)",
                    background: "transparent",
                    color: "var(--ink-light)",
                    fontSize: 13, cursor: "pointer", fontFamily: "var(--font-body)",
                  }}
                >
                  + New list
                </button>
              </div>
            </div>

            {/* Active list area */}
            {activeList && (
              <div style={{ background: "var(--paper-card)", borderRadius: "var(--radius)", border: "1px solid var(--border)", overflow: "hidden" }}>

                {/* List header */}
                <div style={{ padding: "14px 16px", borderBottom: "1px solid var(--border)", display: "flex", alignItems: "center", gap: 10 }}>
                  <span style={{ fontSize: 22 }}>{activeList.emoji || "🧳"}</span>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontFamily: "var(--font-display)", fontSize: 17, fontWeight: 600, color: "var(--ink)" }}>
                      {activeList.name}
                    </div>
                    {!editMode && (
                      <div style={{ fontSize: 12, color: "var(--ink-light)", marginTop: 1 }}>
                        {checkedCount} of {visibleCount} packed
                      </div>
                    )}
                  </div>
                  <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
                    {!editMode && (
                      <button
                        onClick={resetChecks}
                        style={{
                          fontSize: 12, color: "var(--ink-light)", background: "none",
                          border: "1px solid var(--border)", borderRadius: 12,
                          padding: "4px 10px", cursor: "pointer", fontFamily: "var(--font-body)",
                        }}
                      >
                        Reset
                      </button>
                    )}
                    {editMode && !selectMode && (
                      <button
                        onClick={() => { setSelectMode(true); setSelectedIds(new Set()); }}
                        style={{
                          fontSize: 12, color: "var(--ink-light)", background: "none",
                          border: "1px solid var(--border)", borderRadius: 12,
                          padding: "4px 10px", cursor: "pointer", fontFamily: "var(--font-body)",
                        }}
                      >
                        Select
                      </button>
                    )}
                    {selectMode && (
                      <button
                        onClick={() => { setSelectMode(false); setSelectedIds(new Set()); }}
                        style={{
                          fontSize: 12, color: "var(--accent)", background: "none",
                          border: "1px solid var(--accent)", borderRadius: 12,
                          padding: "4px 10px", cursor: "pointer", fontFamily: "var(--font-body)",
                        }}
                      >
                        Cancel
                      </button>
                    )}
                    <button
                      onClick={() => { setEditMode(!editMode); setEditingItemId(null); setAddingItem(false); setSelectMode(false); setSelectedIds(new Set()); }}
                      style={{
                        fontSize: 12,
                        color: editMode ? "var(--accent)" : "var(--ink-light)",
                        background: "none",
                        border: `1px solid ${editMode ? "var(--accent)" : "var(--border)"}`,
                        borderRadius: 12,
                        padding: "4px 10px", cursor: "pointer", fontFamily: "var(--font-body)",
                      }}
                    >
                      {editMode ? "Done" : "Edit"}
                    </button>
                    {isCustom(activeList.id) && !editMode && (
                      <button
                        onClick={() => deleteList(activeList.id)}
                        style={{
                          fontSize: 12, color: "#999", background: "none",
                          border: "1px solid var(--border)", borderRadius: 12,
                          padding: "4px 10px", cursor: "pointer", fontFamily: "var(--font-body)",
                        }}
                      >
                        Delete
                      </button>
                    )}
                  </div>
                </div>

                {/* Season + Gender pickers (only in use mode) */}
                {!editMode && (
                  <div style={{ padding: "10px 16px", borderBottom: "1px solid var(--border)", display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center" }}>
                    {SEASONS.map(s => (
                      <button
                        key={s.id}
                        onClick={() => setSeason(s.id)}
                        style={{
                          fontSize: 12, padding: "4px 12px", borderRadius: 12,
                          border: `1px solid ${season === s.id ? "var(--accent)" : "var(--border)"}`,
                          background: season === s.id ? "rgba(192,86,33,0.08)" : "transparent",
                          color: season === s.id ? "var(--accent)" : "var(--ink-light)",
                          cursor: "pointer", fontFamily: "var(--font-body)", fontWeight: season === s.id ? 600 : 400,
                        }}
                      >
                        {s.label}
                      </button>
                    ))}
                    <div style={{ width: 1, height: 18, background: "var(--border)", margin: "0 4px", flexShrink: 0 }} />
                    {GENDERS.map(g => (
                      <button
                        key={g.id}
                        onClick={() => setGender(g.id)}
                        style={{
                          fontSize: 12, padding: "4px 12px", borderRadius: 12,
                          border: `1px solid ${gender === g.id ? "var(--accent)" : "var(--border)"}`,
                          background: gender === g.id ? "rgba(192,86,33,0.08)" : "transparent",
                          color: gender === g.id ? "var(--accent)" : "var(--ink-light)",
                          cursor: "pointer", fontFamily: "var(--font-body)", fontWeight: gender === g.id ? 600 : 400,
                        }}
                      >
                        {g.label}
                      </button>
                    ))}
                  </div>
                )}

                {/* Items list */}
                <div>
                  {activeList.items.map((item) => {
                    const isHeading = item.type === "heading";
                    const visible = isHeading || itemVisible(item, season, gender);
                    const dimmed = !editMode && !isHeading && !visible;
                    const isEditingThis = editingItemId === item.id;
                    const isEditingQty = editingQtyId === item.id;
                    const isSelected = selectedIds.has(item.id);

                    // ── Heading row ──────────────────────────────────────────
                    if (isHeading) {
                      return (
                        <div
                          key={item.id}
                          style={{
                            display: "flex", alignItems: "center",
                            padding: "8px 16px 4px",
                            borderBottom: "1px solid var(--border)",
                            background: "var(--paper-card)",
                          }}
                        >
                          {(editMode && !selectMode) && (
                            <button
                              onClick={() => removeItem(item.id)}
                              style={{
                                width: 20, height: 20, borderRadius: "50%", flexShrink: 0,
                                border: "none", background: "#e5534b", color: "white",
                                fontSize: 14, lineHeight: 1, cursor: "pointer",
                                display: "flex", alignItems: "center", justifyContent: "center",
                                marginRight: 10,
                              }}
                            >−</button>
                          )}
                          <div style={{ flex: 1, minWidth: 0 }}>
                            {isEditingThis ? (
                              <input
                                autoFocus
                                value={editingLabel}
                                onChange={e => setEditingLabel(e.target.value)}
                                onBlur={() => saveItemLabel(item.id)}
                                onKeyDown={e => { if (e.key === "Enter") saveItemLabel(item.id); if (e.key === "Escape") setEditingItemId(null); }}
                                style={{
                                  fontSize: 12, fontWeight: 700, fontFamily: "var(--font-body)",
                                  border: "none", borderBottom: "1.5px solid var(--accent)",
                                  background: "transparent", outline: "none", width: "100%",
                                  color: "var(--ink-light)", padding: "2px 0", textTransform: "uppercase",
                                  letterSpacing: "0.07em",
                                }}
                              />
                            ) : (
                              <span
                                onClick={() => { if (editMode && !selectMode) { setEditingItemId(item.id); setEditingLabel(item.label); } }}
                                style={{
                                  fontSize: 11, fontWeight: 700, letterSpacing: "0.08em",
                                  textTransform: "uppercase", color: "var(--ink-faint)",
                                  cursor: (editMode && !selectMode) ? "text" : "default",
                                }}
                              >
                                {item.label}
                              </span>
                            )}
                          </div>
                        </div>
                      );
                    }

                    // ── Regular item row ─────────────────────────────────────
                    return (
                      <div
                        key={item.id}
                        onClick={() => { if (selectMode) toggleSelect(item.id); }}
                        style={{
                          display: "flex", alignItems: "center",
                          padding: "11px 16px",
                          borderBottom: "1px solid var(--border)",
                          opacity: dimmed ? 0.35 : 1,
                          transition: "opacity 0.15s, background 0.1s",
                          background: isSelected
                            ? "rgba(192,86,33,0.10)"
                            : item.checked && !editMode
                              ? "rgba(232,184,75,0.06)"
                              : "transparent",
                          cursor: selectMode ? "pointer" : "default",
                        }}
                      >
                        {/* Select mode checkbox */}
                        {selectMode && (
                          <div style={{
                            width: 22, height: 22, borderRadius: 6, flexShrink: 0,
                            border: `2px solid ${isSelected ? "var(--accent)" : "var(--border)"}`,
                            background: isSelected ? "var(--accent)" : "white",
                            display: "flex", alignItems: "center", justifyContent: "center",
                            marginRight: 12, transition: "all 0.15s",
                          }}>
                            {isSelected && (
                              <svg width="11" height="11" viewBox="0 0 12 12" fill="none">
                                <path d="M2 6l3 3 5-5" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                            )}
                          </div>
                        )}

                        {/* Checkbox (use mode only) */}
                        {!editMode && (
                          <button
                            onClick={() => toggleCheck(item.id)}
                            style={{
                              width: 22, height: 22, borderRadius: 6, flexShrink: 0,
                              border: `2px solid ${item.checked ? "var(--gold)" : "var(--border)"}`,
                              background: item.checked ? "var(--gold)" : "white",
                              display: "flex", alignItems: "center", justifyContent: "center",
                              cursor: "pointer",
                              marginRight: 12, transition: "all 0.15s",
                            }}
                          >
                            {item.checked && (
                              <svg width="11" height="11" viewBox="0 0 12 12" fill="none">
                                <path d="M2 6l3 3 5-5" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                            )}
                          </button>
                        )}

                        {/* Remove button (edit mode, not select mode) */}
                        {(editMode && !selectMode) && (
                          <button
                            onClick={() => removeItem(item.id)}
                            style={{
                              width: 20, height: 20, borderRadius: "50%", flexShrink: 0,
                              border: "none", background: "#e5534b", color: "white",
                              fontSize: 14, lineHeight: 1, cursor: "pointer",
                              display: "flex", alignItems: "center", justifyContent: "center",
                              marginRight: 12,
                            }}
                          >−</button>
                        )}

                        {/* Label */}
                        <div style={{ flex: 1, minWidth: 0 }}>
                          {isEditingThis ? (
                            <input
                              autoFocus
                              value={editingLabel}
                              onChange={e => setEditingLabel(e.target.value)}
                              onBlur={() => saveItemLabel(item.id)}
                              onKeyDown={e => { if (e.key === "Enter") saveItemLabel(item.id); if (e.key === "Escape") setEditingItemId(null); }}
                              style={{
                                fontSize: 14, fontFamily: "var(--font-body)",
                                border: "none", borderBottom: "1.5px solid var(--accent)",
                                background: "transparent", outline: "none", width: "100%",
                                color: "var(--ink)", padding: "2px 0",
                              }}
                            />
                          ) : (
                            <span
                              onClick={() => { if (editMode && !selectMode) { setEditingItemId(item.id); setEditingLabel(item.label); } }}
                              style={{
                                fontSize: 14, color: "var(--ink)",
                                textDecoration: item.checked && !editMode ? "line-through" : "none",
                                cursor: (editMode && !selectMode) ? "text" : "default",
                                opacity: item.checked && !editMode ? 0.5 : 1,
                              }}
                            >
                              {item.label}
                            </span>
                          )}
                        </div>

                        {/* Section picker (edit mode, not select mode) */}
                        {(editMode && !selectMode) && (() => {
                          const headings = activeList.items.filter(it => it.type === "heading");
                          if (headings.length === 0) return null;
                          // Find which heading this item currently falls under
                          let currentHeadingId = "__none__";
                          for (let i = activeList.items.indexOf(item) - 1; i >= 0; i--) {
                            if (activeList.items[i].type === "heading") {
                              currentHeadingId = activeList.items[i].id;
                              break;
                            }
                          }
                          return (
                            <select
                              value={currentHeadingId}
                              onChange={(e) => moveToSection([item.id], e.target.value)}
                              onClick={(e) => e.stopPropagation()}
                              style={{
                                fontSize: 11, color: "var(--ink-light)",
                                border: "1px solid var(--border)", borderRadius: 8,
                                padding: "2px 6px", marginLeft: 8,
                                background: "var(--paper)", fontFamily: "var(--font-body)",
                                cursor: "pointer", maxWidth: 90,
                              }}
                            >
                              <option value="__none__">— none —</option>
                              {headings.map(h => (
                                <option key={h.id} value={h.id}>{h.label}</option>
                              ))}
                            </select>
                          );
                        })()}

                        {/* Season tag (edit mode, not select mode) */}
                        {(editMode && !selectMode) && (
                          <select
                            value={item.seasons || "all"}
                            onChange={async (e) => {
                              const updatedItems = activeList.items.map(it =>
                                it.id === item.id ? { ...it, seasons: e.target.value } : it
                              );
                              await saveList({ ...activeList, items: updatedItems });
                            }}
                            style={{
                              fontSize: 11, color: "var(--ink-light)",
                              border: "1px solid var(--border)", borderRadius: 8,
                              padding: "2px 6px", marginLeft: 6,
                              background: "var(--paper)", fontFamily: "var(--font-body)",
                              cursor: "pointer",
                            }}
                          >
                            <option value="all">All</option>
                            <option value="summer">Summer</option>
                            <option value="fall">Fall</option>
                            <option value="winter">Winter</option>
                          </select>
                        )}

                        {/* Gender tag (edit mode, not select mode) */}
                        {(editMode && !selectMode) && (
                          <select
                            value={item.gender || "all"}
                            onChange={async (e) => {
                              const updatedItems = activeList.items.map(it =>
                                it.id === item.id ? { ...it, gender: e.target.value } : it
                              );
                              await saveList({ ...activeList, items: updatedItems });
                            }}
                            style={{
                              fontSize: 11, color: "var(--ink-light)",
                              border: "1px solid var(--border)", borderRadius: 8,
                              padding: "2px 6px", marginLeft: 6,
                              background: "var(--paper)", fontFamily: "var(--font-body)",
                              cursor: "pointer",
                            }}
                          >
                            <option value="all">All</option>
                            <option value="male">♂</option>
                            <option value="female">♀</option>
                          </select>
                        )}

                        {/* Qty badge — editable inline (not in select mode) */}
                        {!selectMode && item.qty !== null && item.qty !== undefined && (
                          isEditingQty ? (
                            <input
                              autoFocus
                              type="number"
                              min="1"
                              value={editingQtyVal}
                              onChange={e => setEditingQtyVal(e.target.value)}
                              onBlur={() => saveQty(item.id)}
                              onKeyDown={e => { if (e.key === "Enter") saveQty(item.id); if (e.key === "Escape") setEditingQtyId(null); }}
                              style={{
                                width: 44, fontSize: 12, textAlign: "center",
                                border: "1px solid var(--accent)", borderRadius: 8,
                                padding: "3px 4px", fontFamily: "var(--font-body)",
                                marginLeft: 6, background: "var(--paper)", color: "var(--ink)",
                              }}
                            />
                          ) : (
                            <button
                              onClick={(e) => { e.stopPropagation(); setEditingQtyId(item.id); setEditingQtyVal(String(item.qty)); }}
                              style={{
                                fontSize: 11, fontWeight: 600,
                                color: item.checked && !editMode ? "var(--ink-faint)" : "var(--accent)",
                                background: "rgba(192,86,33,0.08)",
                                border: "none", borderRadius: 8,
                                padding: "3px 8px", marginLeft: 6,
                                cursor: "pointer", fontFamily: "var(--font-body)",
                              }}
                              title="Tap to change quantity"
                            >
                              ×{item.qty}
                            </button>
                          )
                        )}

                        {/* Add qty if none (edit mode, not select mode) */}
                        {(editMode && !selectMode) && (item.qty === null || item.qty === undefined) && (
                          <button
                            onClick={async (e) => {
                              e.stopPropagation();
                              const updatedItems = activeList.items.map(it =>
                                it.id === item.id ? { ...it, qty: 1 } : it
                              );
                              await saveList({ ...activeList, items: updatedItems });
                            }}
                            style={{
                              fontSize: 11, color: "var(--ink-faint)",
                              background: "none", border: "1px dashed var(--border)",
                              borderRadius: 8, padding: "2px 8px", marginLeft: 6,
                              cursor: "pointer", fontFamily: "var(--font-body)",
                            }}
                          >
                            +qty
                          </button>
                        )}
                      </div>
                    );
                  })}

                  {/* Add item / heading row (edit mode, not select mode) */}
                  {(editMode && !selectMode) && (
                    <div style={{ padding: "10px 16px" }}>
                      {addingItem ? (
                        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                          <input
                            autoFocus
                            placeholder="Item name"
                            value={newItemLabel}
                            onChange={e => setNewItemLabel(e.target.value)}
                            onKeyDown={e => { if (e.key === "Enter") addItem(); if (e.key === "Escape") setAddingItem(false); }}
                            style={{
                              fontSize: 14, fontFamily: "var(--font-body)",
                              border: "1px solid var(--border)", borderRadius: 8,
                              padding: "8px 12px", width: "100%", boxSizing: "border-box",
                              background: "var(--paper)", color: "var(--ink)",
                            }}
                          />
                          <div style={{ display: "flex", gap: 8 }}>
                            <input
                              type="number"
                              min="1"
                              placeholder="Qty (optional)"
                              value={newItemQty}
                              onChange={e => setNewItemQty(e.target.value)}
                              style={{
                                fontSize: 13, fontFamily: "var(--font-body)",
                                border: "1px solid var(--border)", borderRadius: 8,
                                padding: "7px 10px", width: 120,
                                background: "var(--paper)", color: "var(--ink)",
                              }}
                            />
                            <select
                              value={newItemSeason}
                              onChange={e => setNewItemSeason(e.target.value)}
                              style={{
                                fontSize: 13, fontFamily: "var(--font-body)",
                                border: "1px solid var(--border)", borderRadius: 8,
                                padding: "7px 10px", flex: 1,
                                background: "var(--paper)", color: "var(--ink)", cursor: "pointer",
                              }}
                            >
                              <option value="all">All seasons</option>
                              <option value="summer">Spring / Summer</option>
                              <option value="fall">Fall</option>
                              <option value="winter">Winter</option>
                            </select>
                            <select
                              value={newItemGender}
                              onChange={e => setNewItemGender(e.target.value)}
                              style={{
                                fontSize: 13, fontFamily: "var(--font-body)",
                                border: "1px solid var(--border)", borderRadius: 8,
                                padding: "7px 10px", flex: 1,
                                background: "var(--paper)", color: "var(--ink)", cursor: "pointer",
                              }}
                            >
                              <option value="all">All genders</option>
                              <option value="male">♂ Male</option>
                              <option value="female">♀ Female</option>
                            </select>
                          </div>
                          <div style={{ display: "flex", gap: 8 }}>
                            <button onClick={addItem} style={{ flex: 1, padding: "9px", background: "var(--accent)", color: "white", border: "none", borderRadius: 8, fontSize: 14, fontWeight: 500, cursor: "pointer", fontFamily: "var(--font-body)" }}>
                              Add item
                            </button>
                            <button onClick={() => { setAddingItem(false); setNewItemLabel(""); setNewItemQty(""); }} style={{ padding: "9px 16px", background: "none", border: "1px solid var(--border)", borderRadius: 8, fontSize: 14, color: "var(--ink-light)", cursor: "pointer", fontFamily: "var(--font-body)" }}>
                              Cancel
                            </button>
                          </div>
                        </div>
                      ) : addingHeading ? (
                        <div style={{ display: "flex", gap: 8 }}>
                          <input
                            autoFocus
                            placeholder="Heading name (e.g. Gear)"
                            value={newHeadingLabel}
                            onChange={e => setNewHeadingLabel(e.target.value)}
                            onKeyDown={e => {
                              if (e.key === "Enter") { addHeading(newHeadingLabel); setNewHeadingLabel(""); setAddingHeading(false); }
                              if (e.key === "Escape") { setAddingHeading(false); setNewHeadingLabel(""); }
                            }}
                            style={{ fontSize: 14, fontFamily: "var(--font-body)", border: "1px solid var(--border)", borderRadius: 8, padding: "8px 12px", flex: 1, background: "var(--paper)", color: "var(--ink)" }}
                          />
                          <button onClick={() => { addHeading(newHeadingLabel); setNewHeadingLabel(""); setAddingHeading(false); }} style={{ padding: "8px 14px", background: "var(--accent)", color: "white", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 500, cursor: "pointer", fontFamily: "var(--font-body)" }}>Add</button>
                          <button onClick={() => { setAddingHeading(false); setNewHeadingLabel(""); }} style={{ padding: "8px 12px", background: "none", border: "1px solid var(--border)", borderRadius: 8, fontSize: 13, color: "var(--ink-light)", cursor: "pointer", fontFamily: "var(--font-body)" }}>Cancel</button>
                        </div>
                      ) : (
                        <div style={{ display: "flex", gap: 12 }}>
                          <button onClick={() => setAddingItem(true)} style={{ display: "flex", alignItems: "center", gap: 5, fontSize: 13, color: "var(--accent)", background: "none", border: "none", cursor: "pointer", fontFamily: "var(--font-body)", padding: 0 }}>
                            <span style={{ fontSize: 18, lineHeight: 1 }}>+</span> Add item
                          </button>
                          <button onClick={() => setAddingHeading(true)} style={{ display: "flex", alignItems: "center", gap: 5, fontSize: 13, color: "var(--ink-light)", background: "none", border: "none", cursor: "pointer", fontFamily: "var(--font-body)", padding: 0 }}>
                            <span style={{ fontSize: 18, lineHeight: 1 }}>+</span> Add heading
                          </button>
                        </div>
                      )}
                    </div>
                  )}

                  {activeList.items.length === 0 && !editMode && (
                    <div style={{ padding: "24px 16px", textAlign: "center", color: "var(--ink-faint)", fontSize: 13 }}>
                      No items yet. Tap Edit to add some.
                    </div>
                  )}
                </div>

                {/* Multi-select action bar */}
                {selectMode && selectedIds.size > 0 && (() => {
                  const headings = activeList.items.filter(it => it.type === "heading");
                  return (
                    <div style={{
                      position: "sticky", bottom: 0,
                      background: "var(--paper-card)",
                      borderTop: "1px solid var(--border)",
                      padding: "12px 16px",
                      display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap",
                    }}>
                      <span style={{ fontSize: 13, color: "var(--ink-light)", marginRight: 4 }}>
                        {selectedIds.size} selected —
                      </span>
                      <span style={{ fontSize: 13, color: "var(--ink-light)" }}>Move to:</span>
                      {headings.map(h => (
                        <button
                          key={h.id}
                          onClick={() => moveToSection([...selectedIds], h.id)}
                          style={{
                            fontSize: 12, padding: "5px 12px",
                            background: "var(--accent)", color: "white",
                            border: "none", borderRadius: 12,
                            cursor: "pointer", fontFamily: "var(--font-body)", fontWeight: 500,
                          }}
                        >
                          {h.label}
                        </button>
                      ))}
                      <button
                        onClick={deleteSelected}
                        style={{
                          fontSize: 12, padding: "5px 12px",
                          background: "#e5534b", color: "white",
                          border: "none", borderRadius: 12,
                          cursor: "pointer", fontFamily: "var(--font-body)", fontWeight: 500,
                          marginLeft: "auto",
                        }}
                      >
                        Delete
                      </button>
                    </div>
                  );
                })()}

                {/* Saving indicator */}
                {saving && (
                  <div style={{ padding: "8px 16px", fontSize: 11, color: "var(--ink-faint)", textAlign: "right" }}>
                    Saving…
                  </div>
                )}
              </div>
            )}

            {!activeList && allLists.length > 0 && (
              <div style={{ padding: "32px 0", textAlign: "center", color: "var(--ink-faint)", fontSize: 14 }}>
                Select a list above to get started.
              </div>
            )}
          </>
        )}
      </main>

      {/* New list modal */}
      {showNewModal && (
        <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && setShowNewModal(false)}>
          <div className="modal">
            <div className="modal-header">
              <div className="modal-title">New packing list</div>
              <button className="modal-close" onClick={() => setShowNewModal(false)}>
                <Icon name="close" size={14} />
              </button>
            </div>
            <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 12, fontWeight: 600, color: "var(--ink-light)", display: "block", marginBottom: 6 }}>
                Name
              </label>
              <input
                autoFocus
                placeholder="e.g. Safari, Ski trip, Cruise…"
                value={newName}
                onChange={e => setNewName(e.target.value)}
                onKeyDown={e => { if (e.key === "Enter") createList(); }}
                style={{
                  width: "100%", boxSizing: "border-box",
                  padding: "10px 12px", fontSize: 14,
                  border: "1px solid var(--border)", borderRadius: 8,
                  fontFamily: "var(--font-body)", background: "var(--paper)", color: "var(--ink)",
                }}
              />
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={{ fontSize: 12, fontWeight: 600, color: "var(--ink-light)", display: "block", marginBottom: 8 }}>
                Emoji
              </label>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                {["🧳", "⛷️", "🚢", "🏕️", "🎿", "🌍", "🏔️", "🎒", "🚐", "🏄"].map(e => (
                  <button
                    key={e}
                    onClick={() => setNewEmoji(e)}
                    style={{
                      fontSize: 20, padding: "6px 8px",
                      border: `2px solid ${newEmoji === e ? "var(--accent)" : "transparent"}`,
                      borderRadius: 8, background: "none", cursor: "pointer",
                    }}
                  >
                    {e}
                  </button>
                ))}
              </div>
            </div>
            <button
              onClick={createList}
              disabled={!newName.trim()}
              className="submit-btn"
              style={{ background: newName.trim() ? "var(--accent)" : "var(--border)" }}
            >
              Create list
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
